export class ProdutoResumoEditFormModel {
  constructor(
    public id: string = "",
    public tpProduto: number = 0,
    public nome: string = "",
    public imagemUrl: string = "",
    public infAdic: string = '',
  ) { }
}
